export const valueOf = (value, data) => {
  return typeof value === 'function' ? value(data) : value
}
